import router from '@/router';

router.beforeEach(async (to, from, next) => {
     window.scrollTo(0, 0);

     next();
});
